import React from "react";
import { useRouterActions } from "react-resource-router";
import constants from "../../constants";
import { Toast } from "primereact/toast";
import { MegaMenu } from "primereact/megamenu";
import { Menu } from "primereact/menu";
import { InputText } from "primereact/inputtext";
import { Avatar } from "primereact/avatar";
import { Badge } from 'primereact/badge';
import { useAuthStore } from "../../store/AuthStore";
import { useResourcesStore } from "../../store/ResourcesStore";

const HeaderMenue = ({ title, loading, setVisible, setPageLoader }) => {

  const [notification, setNotification] = React.useState(0);
  const menuLeft = React.useRef(null);
  const menuNotification = React.useRef(null);
  const { push } = useRouterActions();
  const [{ id, firstName, lastName, email, username, roles },] = useAuthStore();
  const [,{onSelectPage}] = useResourcesStore();

  const goToProfile = () => {
    console.log("Enter profile func");
  };

  let items = [
    {
      icon: "pi pi-bars",
      command: () => {
        setVisible(true);
      }
    },
    {
      label: "Home",
      icon: "pi pi-home",
      command: () => { push(constants.routes.dashboard); onSelectPage([]) }
    }
  ];


  let endItems = [
    {
      template: () => {
        return (
          <button
            className="w-full p-link flex align-items-center"
          >
            <Avatar
              image="https://primefaces.org/cdn/primereact/images/avatar/amyelsner.png"
              className="mr-2 ml-2"
              shape="circle"
            />
            <div className="flex flex-column align" >
              <span className="font-bold">{firstName} {lastName}</span>
              <span className="text-sm">{username}</span>
            </div>
          </button>
        );
      },  
      command: () => { goToProfile() } 
    },
    { separator: true },
    { label: "Chat Room", icon: "pi pi-comments", command: () => { } },
    { label: "Settings", icon: "pi pi-fw pi-cog", command: () => { } },
    { label: "Logout", icon: "pi pi-power-off", command: () => { push(constants.routes.logout) } }
  ];

  let notificationItems = null;

  const end = (
    <div className="">
      <InputText placeholder="Search" type="text" />
      <Menu model={endItems} popup ref={menuLeft} id="popup_menu_left" />
      <Menu model={notificationItems} popup ref={menuNotification} id="popup_menu_notification" />
      <i
        className="pi pi-bell p-overlay-badge mr-3 ml-3"
        onClick={(event) => menuNotification.current.toggle(event)}
        aria-controls="popup_menu_notification"
        aria-haspopup
        style={{ cursor: "pointer" }}
      >
      {(notification > 0 )?<Badge severity="danger"></Badge>:null}      
      </i>
      <i
        className="pi pi-user mr-3 ml-3"
        onClick={(event) => menuLeft.current.toggle(event)}
        aria-controls="popup_menu_left"
        aria-haspopup
        style={{ cursor: "pointer" }}
      ></i>
    </div>
  );

  return (
    <div className="card">
      <MegaMenu
        model={items}
        orientation="horizontal"
        end={end}
        breakpoint="960px"
      />
    </div>
  );
};

export default HeaderMenue;
